export const SORT_OPTIONS = [
    { label: "Newest First", value: "newest" },
    { label: "Oldest First", value: "oldest" },
    { label: "Name (A-Z)", value: "name" },
    { label: "Duration", value: "duration-desc" },
    { label: "File Size", value: "size-desc" },
];